export function getDashboardProps() {
  const currentPath = window.location.pathname;
  const allowedPaths = ['/mentorship/mentors', '/mentorship/connections', '/mentorship/settings'];
  const isDashboard = allowedPaths.some((allowedPath) => currentPath.includes(allowedPath));
  const dashboardProps = {};

  if (isDashboard) {
    dashboardProps.title = window.programDetails.name;
    dashboardProps.showShare = true;
    dashboardProps.shareUrl = `${window.location.origin}${window.location.pathname}`;
  }

  return dashboardProps;
}

export const checkParams = ({ name, callback, shouldClearParam = true, expectedParamValue = 'true' }) => {
  const params = new URLSearchParams(window.location.search);

  if (params.get(name) === expectedParamValue) {
    callback();

    if (shouldClearParam) {
      params.delete(name);

      const updatedParams = params.toString();
      const newUrl = `${window.location.pathname}${updatedParams ? `?${updatedParams}` : ''}`;
      window.history.replaceState(null, document.title, newUrl);
    }
  }
};

export const addOrRemoveParams = ({ key, value, action }) => {
  const url = new URL(window.location);

  if (action === 'remove') {
    url.searchParams.delete(key);
  } else {
    url.searchParams.set(key, value);
  }

  window.history.pushState(null, '', url.toString());
};
